import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@api/analyticsApi';

export function useOwnerDashboard() {
  return useQuery({
    queryKey: ['analytics', 'owner-dashboard'],
    queryFn: () => analyticsApi.getOwnerDashboard(),
    refetchInterval: 5 * 60 * 1000, // auto-refresh every 5 minutes
  });
}

export function useSalesDashboard() {
  return useQuery({
    queryKey: ['analytics', 'sales-dashboard'],
    queryFn: () => analyticsApi.getSalesDashboard(),
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useWarehouseDashboard() {
  return useQuery({
    queryKey: ['analytics', 'warehouse-dashboard'],
    queryFn: () => analyticsApi.getWarehouseDashboard(),
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useServiceDashboard() {
  return useQuery({
    queryKey: ['analytics', 'service-dashboard'],
    queryFn: () => analyticsApi.getServiceDashboard(),
    refetchInterval: 5 * 60 * 1000,
  });
}
